import styled from '@emotion/styled';

/// AttendeesTabContainer
export const AttendeesTabContainer = styled.div`
  display: flex;
  max-width: 42rem;
  flex-direction: row;
  justify-content: center;
`;
